import { render, staticRenderFns } from "./SigninView.vue?vue&type=template&id=cffe9988"
import script from "./SigninView.vue?vue&type=script&lang=ts"
export * from "./SigninView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports